export default (countryCode: string, locale: string): string =>
  new Intl.DisplayNames([locale], {
    type: "region",
  }).of(countryCode) ?? countryCode;
